export default __webpack_public_path__ + "static/media/employee-portal.c700deef.svg";